<template>
  <div class="address" @click="$emit('select')">
    <div class="address__info--jibun">{{ address.jibunAddress }}</div>
    <span class="address__info--road">
      <span class="road-label">도로명</span>{{ address.roadAddress }}
    </span>
  </div>
</template>
<script>
import toastMessage from "@/components/common/toast.vue";
export default {
  components: { toastMessage },
  props: ["address"],
  methods: {},
};
</script>
<style scoped>
.address {
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
  background-color: var(--white);
  cursor: pointer;
  border-bottom: 1px solid var(--gray-200);
}

.address:hover {
  border-radius: 16px;
  background-color: var(--gray-100);
  border-bottom: none;
  border-top: none;
}

.address .road-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: var(--gray-500);
  border: 1px solid var(--gray-300);
  border-radius: 4px;
  margin-right: 6px;
  box-sizing: border-box;
  padding: 3px 4px;
  display: inline-block;
}

.address__info--jibun {
  color: var(--gray-700);
  font-weight: 400;
}

.address__info--road {
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-500);
  /* display: flex; */
  word-break: break-all;
}

@media all and (min-width: 1024px) {
  .address {
    padding: 20px;
  }
  .address__info--jibun {
    font-size: 20px;
    line-height: 28px;
  }
}
@media all and (max-width: 1023px) {
  .address {
    padding: 16px 12px;
  }
  .address__info--jibun {
    font-size: 18px;
    line-height: 26px;
  }
}
</style>
